import { Button, Group } from '@mantine/core';
import { IconSend, IconSendOff } from '@tabler/icons-react';
import { useSetAtom } from 'jotai';
import { i18nKeys, useTranslation } from 'locales';

import type { Reminder } from '../api';

import { resendReminderModalAtom } from './ResendReminderModal';

type FailedReminderStatusProps = {
  reminder: Reminder;
};

export const FailedReminderStatus = ({ reminder }: FailedReminderStatusProps) => {
  const { t } = useTranslation();

  const dispatch = useSetAtom(resendReminderModalAtom);

  if (reminder.status !== 'failed') return null;

  const handleClickResend = (e: React.MouseEvent) => {
    e.stopPropagation();
    dispatch({ type: 'open', reminder });
  };

  const handleClickIgnore = (e: React.MouseEvent) => {
    e.stopPropagation();
    dispatch({ type: 'ignore', reminder });
  };

  return (
    <Group>
      <Button
        color="gray"
        variant="light"
        onClick={handleClickIgnore}
        leftSection={<IconSendOff stroke={1.5} size={16} />}
      >
        {t(i18nKeys.FAILED_REMINDERS.ACTION_IGNORE)}
      </Button>
      <Button
        onClick={handleClickResend}
        variant="light"
        leftSection={<IconSend stroke={1.5} size={16} />}
      >
        {t(i18nKeys.FAILED_REMINDERS.ACTION_RESEND)}
      </Button>
    </Group>
  );
};
